import { InputProps } from '../OdfjellInputComponent';

const SelectInputComponent: React.FC<Partial<InputProps>> = ({
    value,
    name,
    options,
    selectDefaultOption,
    elementId,
    onChange,
    tabIndex,
    disabled,
}: Partial<InputProps>) => {
    if (!options) return <></>;

    const isObjectArray = (options: any[]): options is { label: string; value: string }[] => {
        return options.length > 0 && typeof options[0] === 'object' && 'label' in options[0] && 'value' in options[0];
    };

    return (
        <select
            id={elementId}
            name={name}
            value={value}
            onChange={(event) => onChange({ event })}
            className={'input-select'}
            tabIndex={tabIndex}
            disabled={disabled}
        >
            {selectDefaultOption && (
                <option key={0} value={selectDefaultOption}>
                    {selectDefaultOption}
                </option>
            )}
            {isObjectArray(options)
                ? options.map((option, index) => (
                      <option key={index + option.label + option.value} value={option.value}>
                          {option.label}
                      </option>
                  ))
                : options.map((option, index) => (
                      <option key={index} value={option}>
                          {option}
                      </option>
                  ))}
        </select>
    );
};

export default SelectInputComponent;
